import { render, staticRenderFns } from "./VisorMetadata.vue?vue&type=template&id=08b37330&scoped=true&"
import script from "./VisorMetadata.vue?vue&type=script&lang=js&"
export * from "./VisorMetadata.vue?vue&type=script&lang=js&"
import style0 from "./VisorMetadata.vue?vue&type=style&index=0&id=08b37330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b37330",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QToolbar,QIcon,QSpace,QBtn,QTooltip,QCardSection,QSpinnerDots,QInput,QSelect,QTable,QTr,QTd});
